// extracted by mini-css-extract-plugin
export default {"typeface":"Typeface_typeface__H1R3k","sample":"Typeface_sample__JLdef"};